import { useEffect, useState } from 'react';
import { ParsinkConfigForm } from '../../../utility/validationRules';
import { useForm } from '../../../utility/useForm';
import { FormProps } from '../../../utility/types';
import { ValidationErrorSpan } from '../../../styles/global';
import { Col, Modal, Row } from 'antd';
import FormContainer from '../../../components/FormContainer/FormContainer';
import CustomTextArea from '../../../components/_common/CustomTextArea';
import { useAppSelector } from '../../../redux/store/storehooks';
import { sendNewParsinkConfig } from '../../../api/api';
import { errorNotify, sucessNotify } from '../../../services/toast.notification';
import CustomSelect from '../../../components/_common/CustomSelect';
declare global {
    interface Navigator {
        msSaveBlob?: (blob: any, defaultName?: string) => boolean
    }
}

export const methods = [
    { id: 1, title: "1" },
    { id: 2, title: "2" },

]

export const NewParsinkConfig: React.FC<FormProps> = ({ visible, onSubmit, onCancel, payLoad, setShowDialog }) => {

    const { values, errors, handleChange, handleSubmit, setErrors, setValues } = useForm(ParsinkConfigForm) as any
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [disableComputerName, setDisableComputerName] = useState(false);
    const myStore = useAppSelector((state) => state)

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type];
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect(() => {
    },)


    const methodHandleChange = (event: any) => {
        
        if (event.target.value === "1") {
            setDisableComputerName(true);
            setValues((values: any) => ({
                ...values,
                computerName: "",
            }));
        }
        else
            setDisableComputerName(false);

        setValues((values: any) => ({
            ...values,
            method: event.target.value,
        }));
    }

    const onSubmitForm = (e: any) => {
        e.preventDefault();

        setIsSubmiting(true)

        sendNewParsinkConfig(payLoad.labId, myStore.auth.userId ? myStore.auth.userId : 0, myStore.auth.userTitle ? myStore.auth.userTitle : "", values.sqlInstance, values.computerName,
            values.macAddress, values.method)
            .then((result: any) => {

                const url = window.URL.createObjectURL(new Blob([result.data.data.base64]));
                const link = document.createElement('a');
                link.href = url;
                if (typeof window.navigator.msSaveBlob === 'function') {
                    window.navigator.msSaveBlob(
                        result.data.data.base64,
                        "Auth.ps"
                    );
                } else {
                    link.setAttribute('download', "Auth.ps");
                    document.body.appendChild(link);
                    link.click();
                }


                sucessNotify("اطلاعات با موفقیت ذخیره شده", undefined, 5000)
                setIsSubmiting(false)
                onCancel();
            })
            .catch((error) => {
                setIsSubmiting(false)
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })


    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                <FormContainer title="افزودن کانفیگ جدید" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="sqlInstance"
                                placeholder="sqlInstance"
                                value={values.sqlInstance || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="sqlInstance" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>

                            <CustomSelect
                                name="method"
                                placeholder="method"
                                itemList={methods}
                                value={values.method || ""}
                                onChange={methodHandleChange}
                                valueObjectField={"id"}
                                displayObjectField={"title"}

                            />

                            <ValidationType type="method" />
                        </Col>

                    </Row>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="computerName"
                                placeholder="computerName"
                                value={values.computerName || ""}
                                onChange={handleChange}
                                disabled={disableComputerName}
                            />
                            <ValidationType type="computerName" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="macAddress"
                                placeholder="macAddress"
                                value={values.macAddress || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="macAddress" />
                        </Col>

                    </Row>

                </FormContainer>
            </>

        </Modal>
    )
}